import { Box, Button, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CustomPopup from "../CustomPopup/CustomPopup";
import { ChevronLeft } from "@mui/icons-material";
import { Colors } from "../../styles/constant";
import useCmsPageVariables from "../../hooks/useCmsPageVariables";
import { defaultEmptyFun } from "../../utils/helper";
import { marked } from "marked";
import DOMPurify from "dompurify";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface PolicyAndConditionsComponentProps {
  title: string;
  open: boolean;
  handleOpen: Function;
  className?: string;
  btnLabel?: string;
  btnStartIcon?: any;
  isAcceptBtnVisible?: boolean;
  acceptBtnFun?: any;
}

const PolicyAndConditionsComponent: FC<PolicyAndConditionsComponentProps> = ({
  title,
  open,
  handleOpen,
  className = "",
  btnLabel = "",
  btnStartIcon = null,
  isAcceptBtnVisible = false,
  acceptBtnFun = defaultEmptyFun,
}) => {
  const { t } = useAppTranslation("common");
  const cmsData = useCmsPageVariables(title);
  const [sanitizedContent, setSanitizedContent] = useState<string>("");
  const richText = cmsData?.attributes?.richText ?? "";

  useEffect(() => {
    const parseAndSanitizeContent = async () => {
      // Marking the richText asynchronously
      const markedContent = await marked(richText, { breaks: true });

      // Sanitizing the content
      const sanitized = DOMPurify.sanitize(markedContent);

      // Update the state with sanitized HTML
      setSanitizedContent(sanitized);
    };

    // Call the function to process the content
    parseAndSanitizeContent();
  }, [richText]);

  const renderPolicyAndConditionsUrlComponent = () => {
    return (
      <Box width="100%" height="70vh" overflow="hidden" position="relative">
        <iframe
          src={cmsData?.attributes?.url || ""}
          width="100%"
          height="100%"
          style={{
            border: "none",
            scrollbarWidth: "none",
          }}
          loading="lazy"
          title="policy-and-conditions-iframe"
          data-testid="policy-and-conditions-iframe"
        ></iframe>
      </Box>
    );
  };

  const renderCustomPopupChildren = () => {
    return (
      <Box
        alignItems={"center"}
        padding={"1rem"}
        className="terms-and-condition-wrapper"
      >
        <Typography
          textAlign={"center"}
          marginBottom={"1.5rem"}
          variant="h6"
          letterSpacing={".0938rem"}
          fontFamily={"PoppinsSemiBold"}
          color={Colors.darkCharcoal}
          className="tac-title"
        >
          {cmsData?.attributes.title}
        </Typography>
        {sanitizedContent && (
          <Typography
            color="#202428"
            textAlign={"left"}
            fontFamily={"PoppinsRegular"}
            className="tac-description"
            dangerouslySetInnerHTML={{ __html: sanitizedContent }}
          />
        )}
        {isAcceptBtnVisible && (
          <Button
            fullWidth
            variant="contained"
            onClick={acceptBtnFun}
            sx={{ marginTop: "1rem" }}
          >
            Accept
          </Button>
        )}
      </Box>
    );
  };

  return (
    <CustomPopup
      open={open}
      handleOpen={handleOpen}
      btnLabel={btnLabel ? btnLabel : t("home.actionButtons.goBack")}
      btnStartIcon={
        btnStartIcon ? (
          btnStartIcon
        ) : (
          <ChevronLeft sx={{ width: "1rem", height: "1rem" }} />
        )
      }
      className={className}
      children={
        title === "li-term&conditions" //render existing functionality for AddUpdateNominee(LI)
          ? renderCustomPopupChildren()
          : renderPolicyAndConditionsUrlComponent()
      }
    />
  );
};

export default PolicyAndConditionsComponent;
